import React from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import Label from "../Steuerelemente/Label.jsx";
import Datafield from "../Steuerelemente/Datafield.jsx";
import Led from "../Geräte/Led.jsx";
import { over } from "lodash";

const AnalogInElement = observer((props) => {
  const name = props.name;
  const {
    anaIn,
    raw,
    upperLimit,
    lowerLimit,
    correction,
    sensorMax,
    sensorMin,
    faultSensor,
  } = props.data;

  //========================================================================
  // Rectangle
  const rectangleStyle = {
    position: "relative",
    left: `calc(${globalVars.scaleFactor} * 10px)`,
    width: `calc(100% - (${globalVars.scaleFactor} * 30px))`,
    height: `calc(${globalVars.scaleFactor} * 40px)`,
    backgroundColor: "rgba(83, 83, 83)",
    borderRadius: `calc(${globalVars.scaleFactor} * 5px)`,
    borderStyle: "none",
    borderWidth: "0px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0",
    paddingLeft: `calc(${globalVars.scaleFactor} * 10px)`,
    overflow: "hidden",
    whiteSpace: "nowrap",
  };

  //========================================================================
  // Label Style
  const labelStyle = {
    width: `calc(${globalVars.scaleFactor} * 605px)`,
    overflow: "hidden",
    whiteSpace: "nowrap",
    fontSize: `calc(${globalVars.scaleFactor} * ${props.style.textFontSize})`,
    color: "#D4CBCB",
    textAlign: "left",
  };

  //========================================================================
  // Datafield Style
  const datafieldStyle = {
    position: "absolute",
    width: `calc(${globalVars.scaleFactor} * 100px)`,
    height: `calc(${globalVars.scaleFactor} * 25px)`,
    fontSize: `calc(${globalVars.scaleFactor} * 14px)`,
    color: "white",
    textHorizontalAlignment: "center",
    textVerticalAlignment: "center",
    borderStyle: "solid",
    borderWidth: `calc(${globalVars.scaleFactor} * 1px)`,
    borderColor: "black",
  };

  const datafieldAiStyle = {
    ...datafieldStyle,
    right: `calc(${globalVars.scaleFactor} * 750px)`,
    backgroundColor: "#2A3845",
  };

  const datafieldRawStyle = {
    ...datafieldStyle,
    right: `calc(${globalVars.scaleFactor} * 635px)`,
    backgroundColor: "#2A3845",
  };

  const datafieldUpperLimitStyle = {
    ...datafieldStyle,
    right: `calc(${globalVars.scaleFactor} * 520px)`,
    backgroundColor: "#13A16B",
  };

  const datafieldLowerLimitStyle = {
    ...datafieldStyle,
    right: `calc(${globalVars.scaleFactor} * 405px)`,
    backgroundColor: "#13A16B",
  };

  const datafieldCorrectionStyle = {
    ...datafieldStyle,
    right: `calc(${globalVars.scaleFactor} * 290px)`,
    backgroundColor: "#13A16B",
  };

  const datafieldSensorMaxStyle = {
    ...datafieldStyle,
    right: `calc(${globalVars.scaleFactor} * 175px)`,
    backgroundColor: "#13A16B",
  };

  const datafieldSensorMinStyle = {
    ...datafieldStyle,
    right: `calc(${globalVars.scaleFactor} * 60px)`,
    backgroundColor: "#13A16B",
  };

  //========================================================================
  // LED Style
  const ledStyle = {
    position: "absolute",
    right: `calc(${globalVars.scaleFactor} * 10px)`,
    width: `calc(${globalVars.scaleFactor} * 18px)`,
    height: `calc(${globalVars.scaleFactor} * 18px)`,
    backgroundColor: "darkgrey",
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "black",
    marginRight: "10px",
  };

  return (
    <div style={{ height: `calc(${globalVars.scaleFactor} * 40px)` }}>
      <div style={rectangleStyle}>
        <Label
          style={labelStyle}
          element={null}
          props={{ text: name, visibility: "visible" }}
        />
        <Datafield
          style={datafieldAiStyle}
          element={{
            textHorizontalAlignment: "center",
            textVerticalAlignment: "center",
          }}
          props={{ variable: anaIn, visibility: "visible" }}
          authWrite={props.authWrite}
        />
        <Datafield
          style={datafieldRawStyle}
          element={{
            textHorizontalAlignment: "center",
            textVerticalAlignment: "center",
          }}
          props={{ variable: raw, visibility: "visible" }}
          authWrite={props.authWrite}
        />
        <Datafield
          style={datafieldUpperLimitStyle}
          element={{
            textHorizontalAlignment: "center",
            textVerticalAlignment: "center",
          }}
          props={{ variable: upperLimit, visibility: "visible" }}
          authWrite={props.authWrite}
        />
        <Datafield
          style={datafieldLowerLimitStyle}
          element={{
            textHorizontalAlignment: "center",
            textVerticalAlignment: "center",
          }}
          props={{ variable: lowerLimit, visibility: "visible" }}
          authWrite={props.authWrite}
        />
        <Datafield
          style={datafieldCorrectionStyle}
          element={{
            textHorizontalAlignment: "center",
            textVerticalAlignment: "center",
          }}
          props={{ variable: correction, visibility: "visible" }}
          authWrite={props.authWrite}
        />
        <Datafield
          style={datafieldSensorMaxStyle}
          element={{
            textHorizontalAlignment: "center",
            textVerticalAlignment: "center",
          }}
          props={{ variable: sensorMax, visibility: "visible" }}
          authWrite={props.authWrite}
        />
        <Datafield
          style={datafieldSensorMinStyle}
          element={{
            textHorizontalAlignment: "center",
            textVerticalAlignment: "center",
          }}
          props={{ variable: sensorMin, visibility: "visible" }}
          authWrite={props.authWrite}
        />
        <Led
          style={ledStyle}
          element={{ activeColor: "red" }}
          props={{ variable: faultSensor, visibility: "visible" }}
        />
      </div>
    </div>
  );
});

export default AnalogInElement;
